var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['emd-tag', _vm.classList]},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('i',{staticClass:"uil uil-times-circle",attrs:{"transform":"width-16"},on:{"click":function($event){return _vm.$emit('remove')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }